<template>
  <div>
    <template v-if="$options.components['advertisement-loading']">
      <advertisement-loading v-if="isLoading" />
    </template>
    <div
      v-if="productList.length == 0 && !isLoading"
      class="text-center no-item"
    >
      {{ $t("productStore.noItmes") }}
    </div>

    <div>
      <b-card class="text-grey mx-5 my-4">
        <b-row>
          <b-col md="3">
            <!-- <h4 class="ml-3 mt-2">Filter By Distance</h4> -->
          </b-col>
          <b-col md="4">
            <!-- <b-form-input
            id="range-1"
            v-model="value"
            type="range"
            min="0"
            max="10"
            class="w-50 mt-2 margin-left-55"
          >
          </b-form-input> -->
          </b-col>
          <b-col md="2">
            <!-- <div class="mt-2 margin-left-235">Distance: {{ value }}km to {{ max }}km</div> -->
          </b-col>
          <b-col md="3">
            <b-row>
              <b-form-input
                class="mt-2 col-10 border-radius-left-40"
                placeholder="Search Store..."
                v-model="storeName"
              ></b-form-input>
              <button
                class="col search-button mt-2 ml-n1 border-radius-r-40"
                @click="storeResult"
              >
                <b-icon icon="search" class="margin-top-4"></b-icon>
              </button>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <sections-slider
        v-if="productList && productList.length"
        :list="productList"
        :subTitle="$route.params.market"
        :showTitle="true"
        :hasBackground="false"
        :hasButton="false"
        :withoutSlider="true"
      >
        <template slot="default" slot-scope="{ listItem }">
          <div class="item-box">
            <items-item
              :isDoctor="true"
              :itemNoBg="true"
              :product="listItem"
              :incrementDecrementKey="true"
              :rating="listItem.avgRating || 0"
              class="suggester-div w-100"
            ></items-item>
          </div>
        </template>
      </sections-slider>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      isLoading: false,
      storeName: "",
    };
  },
  computed: {
    ...mapState({
      productList: (state) => state.healthCare.healthCareProductsList,
      currentPosition: (state) => state.location.currentPosition,
    }),
  },

  methods: {
    ...mapActions({
      fetchPharmacyStore: "healthCare/fetchPharmacyStore",
    }),
    async storeResult() {
      await this.getPharmacyData();
    },

    async getPharmacyData() {
      const payload = {
        category: "SELLER",
        name: "",
        state: "",
        city: "",
        zip: "",
        street: "",
        market: "",
        lat: this.currentPosition.Lat || 0,
        lng: this.currentPosition.Lng || 0,
        // lat: 17.385044,
        // lng: 78.486671,
        radius: 5,
      };
      if (this.storeName) {
        payload.name = this.storeName;
      }
      await this.fetchPharmacyStore(payload);
    },
  },

  async mounted() {
    this.isLoading = true;
    let payload = {
      categoryId: this.$route.params.id,
      offset: 0,
    };
    await this.$store.dispatch(
      "healthCare/fetchHealthCareProductList",
      payload
    );
    this.isLoading = false;
    await this.getPharmacyData();
  },
};
</script>

<style scoped>
.search-button {
  position: absolute;
  top: 0px;
  font-size: large;
  z-index: 1;
  width: 46px;
  height: 38px;
  padding: 0px;
  background-color: black !important;
  color: #fff;
}
</style>
